



































import {Component, Vue} from 'vue-property-decorator';
import ReportContainer from '../../components/report-container/report-container.vue';
import FilterContainer from '../../components/filter-container/filter-container.vue';
import ReportViewerContainer from '../../components/report-viewer-container/report-viewer-container.vue';
import FilterDropDown from '@/modules/neodash/components/filter-form/filter-drop-down/filterDropDown.vue';
import {NameValues, OptionalNameValue} from '@/modules/neodash/model/types/interfaces/NameValue';
import {listAllTypesLocalityLevel} from '@/modules/neodash/model/constants/typeLocalityLevel';
import {FilterService} from '@/modules/neodash/services/filterService';
import {listAllSaleTypes} from '@/modules/neodash/model/constants/saleType';
import {IKeyValues} from '@/interfaces/key-value-interface';
import {i18nMixin} from '@/modules/neodash/mixins';
import {getUrlReportViewer} from '@/modules/neodash/model/constants/reportViewer';
import {ReportsReportViewerEnum} from '@/modules/neodash/model/types/enums/reportsReportViewerEnum';
import {traceLogAccess} from '@/services';
import {ContextEnum} from '@/enums/context.enum';

@Component({
  name: 'MarketEvolution',
  components: {
    ReportContainer,
    FilterContainer,
    ReportViewerContainer,
    FilterDropDown
  }
})
export default class MarketEvolution extends Vue {
  public readonly translate = i18nMixin.methods.i18n;

  public readonly typesLocalityLevel: NameValues = listAllTypesLocalityLevel();
  public readonly salesTypes: NameValues = listAllSaleTypes();

  public localeTypes: NameValues = [];
  public locations: NameValues = [];

  public typeLocalityLevel: OptionalNameValue = null;
  public localeType: OptionalNameValue = null;
  public location: OptionalNameValue = null;
  public saleType: OptionalNameValue = null;

  public labelFilters: IKeyValues = [];
  public url: string = '';

  public showReport() {
    const {saleType, localeType, location} = this;

    const params = {
      localityType: localeType,
      idLocale: location,
      tipoVenda: saleType
    };

    traceLogAccess.logAction(ContextEnum.Report, `Evolução do Mercado - Filtro`, JSON.stringify(params));
    this.url = getUrlReportViewer(ReportsReportViewerEnum.MarketEvolution, params);
    this.updateLabelFilters();
  }

  public updateLabelFilters(): void {
    const {saleType, translate, localeType, location} = this;

    if (!saleType || !localeType || !location)
      return;

    this.labelFilters = [
      {text: translate('Common.SaleType'), value: saleType.name},
    ]
  }

  public get formValid(): boolean {
    const {localeType, location, saleType} = this;
    if (!localeType || !location || !saleType)
      return false;

    return localeType.value != null && location.value != null && !!saleType.value;
  }

  public updateTypeLocales() {
    this.localeType = null;
    this.localeTypes = [];

    this.updateLocations();
    const {typeLocalityLevel} = this;
    if (!typeLocalityLevel || !typeLocalityLevel.value)
      return;

    FilterService.getTypeLocationByTypeResolutionLevel(typeLocalityLevel.value)
        .then(x => this.localeTypes = x);
  }

  public updateLocations() {
    this.location = null;
    this.locations = [];

    const {localeType} = this;
    if (!localeType || localeType.value == null)
      return;

    FilterService.getLocationsByType(localeType.value)
        .then(x => this.locations = x);
  }
}
